import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_KEY__ZONE = 'zone';

export class ZoneState {
  type?: string;
  errorWrapper?: ErrorWrapper;
  zoneId?: string;
  loading: boolean;
}

const defaultState: ZoneState = {
  loading: false,
};

export default (state: ZoneState = defaultState, action: Action): ZoneState => {
  return state;
};
